import React from 'react';
import c from '../w.js';

const IconChevronLeftSmall = React.memo(
  c(
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.4142 12.0001L15.7071 6.70718L14.2929 5.29297L7.58582 12.0001L14.2929 18.7072L15.7071 17.293L10.4142 12.0001Z"
      }
    )
  )
);

export { IconChevronLeftSmall };
